import { render, staticRenderFns } from "./LessonView.vue?vue&type=template&id=8ac66172"
import script from "./LessonView.vue?vue&type=script&lang=js"
export * from "./LessonView.vue?vue&type=script&lang=js"
import style0 from "./LessonView.vue?vue&type=style&index=0&id=8ac66172&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports